module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("\n    " + _vm._s(_vm.header) + "\n  ")]), _vm._v(" "), (!_vm.isValidCategory) ? _vm._l((_vm.categories), function(category, key) {
    return _c('category-info-block', {
      attrs: {
        "category": category,
        "categoryId": key
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.isValidCategory) ? [_c('div', {
    staticClass: "category-metadata"
  }, [_vm._v("\n      " + _vm._s(_vm.category.quota) + " blocks/day\n      "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "block",
    style: (_vm.blockColorString)
  })]), _vm._v(" "), _c('edit-category-trigger', {
    attrs: {
      "categoryId": _vm.category.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "category-stats"
  }, [_c('br'), _vm._v("\n      Category Stats\n      "), _c('ul', [_c('li', [_vm._v("- Total number of blocks completed")]), _vm._v(" "), _c('li', [_vm._v("- Graph of daily completions")]), _vm._v(" "), _c('li', [_vm._v("- Schedule")]), _vm._v(" "), _c('li', [_vm._v("- Milestone/long-term goal")]), _vm._v(" "), _c('li', [_vm._v("- Intentional hours")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.category.summaries))])])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-df323ca6!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/CategoryView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-df323ca6!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/CategoryView.vue
// module chunks = 0